import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconOrSpinnerComponent } from './icon-or-spinner.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [IconOrSpinnerComponent],
  imports: [CommonModule, MatIconModule],
  exports: [IconOrSpinnerComponent],
})
export class IconOrSpinnerModule {}
